import { render, staticRenderFns } from "./ProductionOverview.vue?vue&type=template&id=150a2edc&scoped=true&"
import script from "./ProductionOverview.vue?vue&type=script&lang=js&"
export * from "./ProductionOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOverview.vue?vue&type=style&index=0&id=150a2edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a2edc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBadge,VBtn,VCard,VDivider,VIcon,VImg,VMenu,VSwitch})
